import { UPDATE_NOTIFICATIONS } from "../actions"

const initialState = {
notifications:[]
}

const notificationsReducer =   (state = initialState, action) => {
    switch (action.type) {

    case UPDATE_NOTIFICATIONS:
        return { ...state, notifications:[...action.notifications] }

    default:
        return state
    }
}

export default notificationsReducer;
